<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        {{ edit ? `Edit Fee Type` : "Add Fee Type" }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model.trim="form.code"
              label="Code*"
              outlined
              dense
              maxlength="3"
              hide-details="auto"
              :rules="[rules.required, (v) => /^[A-Z]+$/.test(v) || 'Code should be alphabets only', (v) => v.length <= 3 || 'Code should be 3 characters long']"
              readonly
              hint="Set from the fee name"
              persistent-hint
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.name"
              :items="feeNames"
              item-text="name"
              item-value="name"
              label="Name*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
              :disabled="edit && form.type == 'S'"
              @change="onNameChange"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.categories"
              :items="categories"
              label="Service Categories*"
              outlined
              dense
              hide-details="auto"
              multiple
              chips
              small-chips
              deletable-chips
              :rules="[(v) => (v && v.length > 0) || 'Pick at least one']"
              hint="Tuition is charged under both Admission and Academic Support, so a fee type can belong to more than one."
              persistent-hint
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="form.is_self" label="Self Partner" hide-details="auto" dense></v-checkbox>
            <v-checkbox v-model="form.is_business" label="Business Partner" hide-details="auto" dense></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">
          {{ edit ? "Update" : "Save" }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    feeType: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      categories: [
        "Admission Service",
        "Academic Support Service",
        "Online Education Support Service",
        "Examination Support Service",
      ],
      feeNames: [
        { name: "Term Fee", code: "TMF", categories: ["Admission Service", "Academic Support Service"] },
        { name: "Annual Upfront Fee", code: "AUF", categories: ["Admission Service", "Academic Support Service"] },
        { name: "Full Upfront Fee", code: "FUF", categories: ["Admission Service", "Academic Support Service"] },
        { name: "Re-Admission Fee", code: "RAD", categories: ["Online Education Support Service"] },
        { name: "Convocation Fee", code: "CNV", categories: ["Online Education Support Service"] },
        { name: "Postal Fee", code: "PST", categories: ["Online Education Support Service"] },
        { name: "Exam Fee", code: "EXM", categories: ["Examination Support Service"] },
      ],
      form: {
        code: "",
        name: "",
        categories: [],
        type: "M", 
        is_self: false,
        is_business: false,
        active: true,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.edit && this.feeType) {
        this.form = {
          ...this.feeType,
          categories: this.feeType.categories?.length
            ? [...this.feeType.categories]
            : this.feeType.category
              ? [this.feeType.category]
              : [],
        };
      }
    },

    onNameChange(name) {
      const preset = this.feeNames.find((item) => item.name === name);
      if (!preset) return;
      this.form.code = preset.code;
      if (!this.form.categories.length) {
        this.form.categories = [...preset.categories];
      }
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (this.edit) {
        this.$emit("update", this.form);
      } else {
        this.$emit("create", this.form);
      }
    },
  },
};
</script>

<style scoped></style>
